import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../../Components/Layout";
import {
  Card,
  Badge,
  ListGroup,
  Row,
  Col,
  Table,
  Collapse,
} from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { Icon } from "@iconify/react";
import { ProgressBar } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function OffboardingDetails() {
   const navigate = useNavigate();
   const [employee, setEmployee] = useState({});
  const [taskData, setTaskData] = useState({
    totalCompleted: 0,
    totalTasks: 0,
    categories: [],
  });
  const [managerApproval, setManagerApproval] = useState({});
  const [expandedIndex, setExpandedIndex] = useState(null);
const { id } = useParams(); // id = OB-21887ACC
const [lastWorkingDay, setLastWorkingDay] = useState("");


  useEffect(() => {
  if (id) {
    fetchOffboardingProgress();
  }
}, [id]);
const token = localStorage.getItem("token");



const fetchOffboardingProgress = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/${id}/progress`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = res.data;



    setEmployee({
      name: data.employeeName,
      id: data.employeeCode,
      position: data.position,
      department: data.department,
      lastWorkingDay: data.lastWorkingDay,
      status: data.status,
      offboardingType: data.offboardingType,
    });

    setManagerApproval(data.managerApproval);


setLastWorkingDay(data.lastWorkingDay || "");


  const hrApproval = data.approvals?.find(
  (a) => a.approverRole === "ROLE_HR"
);
const isHRApproved = hrApproval?.decision === "APPROVED";

const isManagerApproved =
  data.approvals?.some(
    (a) => a.approverRole === "ROLE_MANAGER" && a.decision === "APPROVED"
  );

setTaskData({
  totalCompleted:
    data.completedTasks +
    (isManagerApproved ? 1 : 0) +
    (isHRApproved ? 1 : 0),

  totalTasks: data.totalTasks + 2, // Manager + HR

  categories: [
    

    // 🔹 HR Approval
{
  title: "HR Approval",
  completed: isHRApproved ? 1 : 0,
  total: 1,
  status: hrApproval?.decision || "PENDING",
  tasks: [
    {
      title: isHRApproved
        ? `Approved by ${hrApproval.approverName}`
        : "Pending approval from HR",
      status: hrApproval?.decision || "PENDING",
    },
  ],
},

// 🔹 Manager Approval
{
  title: "Manager Approval",
  completed: isManagerApproved ? 1 : 0,
  total: 1,
  status: isManagerApproved ? "APPROVED" : "PENDING",
  tasks: [
    {
      title: isManagerApproved
        ? "Approved by Manager"
        : "Pending approval from Manager",
      status: isManagerApproved ? "APPROVED" : "PENDING",
    },
  ],
},


    // 🔹 Department Tasks
    ...data.departmentProgress.map((dept) => ({
      title: dept.department,
      completed: dept.completedTasks,
      total: dept.totalTasks,
      status: dept.status,
     
      tasks: dept.tasks.map((t) => ({
  title: t.title,
  status: t.status,
})),

    })),
  ],
});



  } catch (error) {
    console.error("Failed to fetch offboarding progress", error);
  }
};

const submitDecision = async (updatedDate) => {
  try {
    const token = localStorage.getItem("token");

    const payload = {
      decision: "APPROVED",     // ✅ AUTO
      comments: "",             // ✅ EMPTY
      lastWorkingDay: updatedDate,
    };

    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/${id}/approve`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Last Working Day updated successfully");

  } catch (error) {
    console.error("Update failed:", error);
    toast.error(
      error?.response?.data?.message || "Failed to update last working day"
    );
  }
};




  const toggleCard = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  const handleBack = () => {
    // You can use react-router's useNavigate or history.back()
    window.history.back();
  };



const progressPercent =
  taskData.totalTasks > 0
    ? (taskData.totalCompleted / taskData.totalTasks) * 100
    : 0;




  return (
    <Layout>
      <div className="backgound-main-content">
        <button
          onClick={handleBack}
          className="btn d-flex align-items-center mb-3"
          style={{
            color: "#6c757d",
            fontWeight: "500",
            fontSize: "16px",
            background: "none",
            border: "none",
          }}
        >
          <Icon
            icon="akar-icons:arrow-left"
            style={{
              width: "24px",
              height: "24px",
              marginRight: "8px",
              transform: "rotate(0deg)",
              opacity: 1,
            }}
          />
          Back
        </button>

        <h2 className="mb-2">Offboarding Progress</h2>
        <p className="text-muted mb-4">
          Monitor and manage the offboarding process
        </p>

        <Card
          className="shadow-sm p-4  d-block h-25 mb-5"
          style={{ backgroundColor: "#F5F5F5" }}
        >
          <Row className="mb-4">
            <Col xs={12} sm={6} md={3}>
              <label>Employee</label>
              <div className="" style={{fontWeight:450}}>{employee.name}</div>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <label>Employee ID</label>
              <div style={{fontWeight:450}}>{employee.id}</div>
            </Col>
          
<Col xs={12} sm={6} md={3}>
  <label>Last Working Day</label>
 

<DatePicker
  selected={lastWorkingDay ? new Date(lastWorkingDay) : null}
  onChange={(date) => {
    if (!date) return;
    const selectedDate = date.toISOString().split("T")[0];
    setLastWorkingDay(selectedDate);
    submitDecision(selectedDate);
  }}
  dateFormat="yyyy-MM-dd"
  customInput={
    <div
      className="form-control d-flex align-items-center justify-content-between"
      style={{ width: "152px", cursor: "pointer" }}
    >
      <span>{lastWorkingDay || "YYYY-MM-DD"}</span>
      <Icon icon="uil:calendar" style={{ fontSize: "18px", color: "#00AFEF" }} />
    </div>
  }
/>


</Col>


            <Col xs={12} sm={6} md={3}>
              <label >Status</label>
              <div>
               <span
  style={{
    backgroundColor:
      employee.status === "APPROVED" ? "#E6FFEF" : "#FFFED9",
    color: "#000",
    padding: "0.4em 0.75em",
    borderRadius: "20px",
    fontWeight: "500",
    display: "inline-block",
    fontWeight:450
  }}
>
  {employee.status}
</span>

              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6} md={3}>
              <label>Position</label>
              <div style={{fontWeight:450}}>{employee.position}</div>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <label>Department</label>
              <div style={{fontWeight:450}}>{employee.department}</div>
            </Col>
            <Col xs={12} sm={6} md={3}>
              <label>Offboarding Type</label>
              <div style={{fontWeight:450}}>{employee.offboardingType}</div>
            </Col>
          </Row>
        
        </Card>
        {/* Manager Approval Section */}




        {/* track progress */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Track Progress</h5>
          {taskData.totalCompleted}/{taskData.totalTasks} Tasks
        </div>
        {/* User Progress Bar */}
        <div className="progress flex-grow-1 mb-3" style={{ height: "6px" }}>
          
  <div
  className="progress-bar"
  role="progressbar"
  style={{
    width: `${progressPercent}%`,
    backgroundColor: "#00AFEF",
  }}
></div>


        </div>
        <div className="d-flex flex-wrap gap-3">
          {taskData.categories.map((category, index) => (
            <Card
              key={index}
              className="p-3 mb-4 shadow-sm border"
              style={{
                cursor: "default",
                display: "flow",
                width: "100%",
                height: "100%",
              }}
            >
              <div
                className="d-flex flex-wrap mb-3 gap-2"
                style={{ cursor: "pointer" }}
                onClick={() => toggleCard(index)} // expand on click anywhere
              >
                {/* Left section: Icon + Title */}
                <div
                  className="flex-fill d-flex align-items-center gap-2"
                  style={{ minWidth: "200px" }}
                >
                  <div
                    className="mb-2"
                    style={{
                      backgroundColor: "#E0FFEC", // light green
                      padding: "8px",
                      borderRadius: "10px",
                      color: "#22C55E", // dark green text
                    }}
                  >
                    <Icon icon="lets-icons:done-ring-round" size={50} />
                  </div>
                  <span className="fw-bold">{category.title}</span>
                </div>

                {/* Middle section: task count */}
                <div
                  className="flex-fill text-muted text-center d-flex justify-content-end"
                  style={{ minWidth: "200px" }}
                >
                  {category.completed}/{category.total} tasks completed
                </div>

                {/* Right section: status + button */}
                <div
                  className="flex-fill d-flex justify-content-end align-items-center"
                  style={{ minWidth: "200px" }}
                >

<div
  style={{
    backgroundColor:
      category.status === "APPROVED" || category.status === "COMPLETED"
        ? "#E6FFEF"
        : "#FFFED9",
    color:
      category.status === "APPROVED" || category.status === "COMPLETED"
        ? "#22C55E"
        : "#A39D00",
    padding: "0.25em 0.5em",
    borderRadius: "0.25rem",
    fontWeight: "500",
  }}
>
  {category.status}
</div>




                  <button
                   
                    onClick={(e) => {
                      e.stopPropagation(); // prevent parent click from firing
                      toggleCard(index);
                    }}
                  >
                    <Icon
                      icon={
                        expandedIndex === index
                          ? "mdi:chevron-up"
                          : "mdi:chevron-down"
                      }
                      style={{ fontSize: "22px", color: "#606060" }}
                    />
                  </button>
                </div>
              </div>

              {/* Task list */}
              <Collapse in={expandedIndex === index}>
                <div>
                  <ul className="list-unstyled mb-0">
                   


                        {category.tasks.map((task, i) => (
  <li
    key={i}
    className="d-flex align-items-center mb-2"
    style={{
      color: ["COMPLETED", "APPROVED"].includes(task.status)
        ? "#22C55E"
        : "#303030",
    }}
  >
    <Icon
      icon={
        ["COMPLETED", "APPROVED"].includes(task.status)
          ? "material-symbols:check-rounded"
          : "material-symbols-light:pending-outline"
      }
      style={{
        fontSize: "20px",
        marginRight: "8px",
      }}
    />
    <span>{task.title}</span>
  </li>
))}


                  </ul>
                </div>
              </Collapse>

              
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default OffboardingDetails;